// 公共組件翻譯匯總
import button from "./button.js";
import input from "./input.js";
import customerService from "./customer-service.js";
import chart from "./chart.js";

export default {
  button,
  input,
  customerService,
  chart,
  // 通用消息
  languageSwitched: "語言已切換為",
  loading: "加載中...",
  success: "成功",
  error: "錯誤",
  warning: "警告",
  confirm: "確認",
  cancel: "取消",
  empty: "暫無數據",
  // 網絡請求錯誤
  networkError: "網絡異常，請檢查網絡，或者稍後重試",
  requestTimeout: "請求超時，請檢查網絡或稍後重試",
  // 專業版功能提示彈窗（$tbProFeature）
  proFeature: {
    title: "系統提示",
    description: "當前功能僅專業版用戶可用，請掃碼諮詢客服",
    qrAlt: "客服二維碼",
    confirm: "知道了",
  },
};
